module.exports = __webpack_public_path__ + "static/media/basel-10.95bb1e0b.jpg";